module.exports = __webpack_public_path__ + "384402178110b38e1e588b2e3cb328a1.svg";